<page-headline
    [linkTitle]="''"
    [module]="pageHeadline.module"
    [moduleIcon]="pageHeadline.moduleIcon"
    [moduleLink]="pageHeadline.moduleLink"
    [pageTitle]="pageHeadline.pageTitle"
    [linkArray]="pageHeadline.linkArray"
>
</page-headline>
<div>
    <div>
        <div>
            <main-filters (filtersOutput)="applyNewFilters($event)"></main-filters>
            <div class="displayopt-actionpanel-layout">
                <display-options
                    (displayOptionsOutput)="applyDisplayOptions($event)"
                    [extraParameters]="extraParameters"
                    [showRollingDateRange]="false"
                >
                </display-options>
                <action-panel
                    [showExportCsv]="false"
                    [showSaveAsPdf]="true"
                    [showPrint]="false"
                    [title]="pageTitle"
                >
                </action-panel>
            </div>
        </div>
        <div class="row-layout-track layout-padding-bottom__2rem">
            <div *ngFor="let incentivesSmallChart of incentivesSmallCards" class="incentives-small-card">
                <small-card
                    [mainValueFontSize]="mainValueFontSize"
                    [(smallCardData)]="incentivesSmallChart.data"
                ></small-card>
            </div>
        </div>
        <div class="row-layout-track layout-padding-bottom__1_5rem incentives-large-cards">
            <div *ngFor="let incentivesLargeChart of incentivesLargeCharts" class="incentives-large-card-container">
                <large-card
                    [largeCardInteriorOptions]="incentivesLargeChart.largeCardInteriorOptions"
                ></large-card>
            </div>
        </div>
    </div>
</div>
